import { Theme } from "@mui/material";

export const formControlStyles = {
  position: "relative",
  width: "100%",

  "& .MuiFormControl-root": {
    padding: 0,
  },
};

export const getInputStyles = (
  isMobile: boolean,
  theme: Theme,
  isCardNumber: boolean = false
) => ({
  "& .MuiOutlinedInput-root": {
    fontSize: `${isMobile ? "1rem" : "1.125rem"}`,
    fontWeight: 500,
    fontFamily: '"Mulish",sans-serif',

    "& input": {
      padding: !isCardNumber ? "12px" : "12px 12px 12px 48px",
    },

    "& fieldset": {
      borderColor: "#e5e5e5",
      borderRadius: "8px",
    },
    "& input::placeholder": {
      color: theme.palette.grey[400],
      opacity: 1,
    },
  },
});

export const iconCardStyles = {
  top: "50%",
  left: "4px",
  transform: "translateY(-50%)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",

  "& .MuiAvatar-root": {
    backgroundColor: "transparent",
  },
  "& svg": { width: 24 },
};
